import { Component } from 'react';
import { INPAGE_SIDEBAR_IFRAME_WINDOW_NAME } from 'ContentEditorUI/lib/app/constants';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
class SidebarTooltip extends Component {
  constructor(props) {
    super(props);
    const parent = window.parent;
    if (parent !== null && parent !== void 0 && parent.frames[INPAGE_SIDEBAR_IFRAME_WINDOW_NAME]) {
      this.sidebarIframeBody = parent.frames[INPAGE_SIDEBAR_IFRAME_WINDOW_NAME].document.body;
    }
  }
  render() {
    const {
      children,
      title,
      placement,
      disabled,
      autoPlacement
    } = this.props;
    return /*#__PURE__*/_jsx(Tooltip, {
      title: title,
      placement: placement,
      _bodyElement: this.sidebarIframeBody,
      disabled: disabled,
      autoPlacement: autoPlacement,
      children: children
    });
  }
}
export default SidebarTooltip;